import ICLICommand from "flow/interfaces/ICLICommand";
import Writer from "../Writer";
import workspace from "flow/viewModels/workspace";
import ToolbarItemManifestEx from "flow/manifests/ToolbarItemManifestEx";
import { Dictionary } from "flow/api/types";
import manifestManager from "flow/utils/manifestManager";

type PrintConfig = {
    showId: boolean;
    showModule: boolean;
    showOrder: boolean;
};

function anyExtra(printConfig: PrintConfig) {
    return printConfig.showId || printConfig.showModule || printConfig.showOrder;
}

function addSeparatorIfNeeded(text: string, printConfig: PrintConfig) {
    return anyExtra(printConfig) ? text + " -- " : text;
}

function printMenuItem(toolbarItem: ToolbarItemManifestEx, writer: Writer, printConfig: PrintConfig) {
    let line = addSeparatorIfNeeded(toolbarItem.tooltip, printConfig);

    if (printConfig.showOrder) {
        line += ` (${toolbarItem.order})`;
    }

    if (printConfig.showId) {
        line += ` ${toolbarItem.id}`;
    }

    if (printConfig.showModule) {
        const manifest = manifestManager.getManifestWithId(toolbarItem.id);
        line += ` ${manifest.moduleId}`;
    }

    writer.output.writeLine(line);
}

export default {
    name: "list-menu-order",
    description: "List menu items and their order values",
    options: [
        {
            name: "all",
            shortName: "a",
            description: "show all info",
            defaultValue: false,
            type: "boolean"
        },

        {
            name: "id",
            shortName: "i",
            description: "show manifest id",
            defaultValue: false,
            type: "boolean"
        },
        {
            name: "module",
            shortName: "m",
            description: "show module id",
            defaultValue: false,
            type: "boolean"
        },
        {
            name: "order",
            shortName: "o",
            description: "show order",
            defaultValue: true,
            type: "boolean",
            hasArgument: true
        }
    ],
    arguments: [],
    callback(writer: Writer, optsAndArgs: Dictionary) {
        const printConfig: PrintConfig = {
            showId: optsAndArgs.id || optsAndArgs.all,
            showModule: optsAndArgs.module || optsAndArgs.all,
            showOrder: optsAndArgs.order || optsAndArgs.all
        };

        const menuItems = workspace.getAllNavigationPanelItems();
        menuItems.forEach(item => printMenuItem(item, writer, printConfig));

        return {
            input: ""
        };
    }
} as ICLICommand;
